var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-center"},[_c('div',{staticClass:"copyright d-flex flex-wrap"},[_c('i',{staticClass:"fa fa-cubes"}),_c('div',[_c('img',{staticStyle:{"width":"60px","padding":"0 6px"},attrs:{"src":require("@/assets/img/sensoreal-logo-dark.png"),"alt":""}})])])])])
}]

export { render, staticRenderFns }